import React from 'react';
import styles from './MediaButton.module.scss';
import {ButtonProps, MediaButtonType} from "../../../types/button.types";

interface MediaButtonProps extends ButtonProps {
    buttonType: MediaButtonType
}

const MediaButton = (props: MediaButtonProps) => {
    return (
        <div className={[styles['media-button'], styles[props.styleType]].join(" ")} onClick={props.callback}>
            {
                <span className={"material-symbols-outlined " + styles['button-icon']}>{props.buttonType}</span>
            }
        </div>
    );
}

export default MediaButton;
